import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,_vm._g(_vm._b({class:_vm.classes,attrs:{"type":_vm.type}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }